import React from "react";
import { Grid, Tooltip, Typography } from "@mui/material";
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {getDateFormat } from "utils/utils";
import download from "assets/images/download.png";
import pdf from 'assets/images/pdfImg.svg';

function CommonCardDetails({ md, sm, val, handleOpen, onReuploadClick }) {
  const isExpired = (date) => {
    if (!date) return false;
    return new Date(date) < new Date();
  };

  const showReupload = val.status === "Rejected" || (val?.status === "Approved" && isExpired(val?.expiryDate));

  return (
    <>
      <Grid
        item
        md={md}
        sm={sm}
        key={val?.id}
        className="borderStyle padding10 m10"
      >
        <div
          className={` ${val?.complianceFile?.name.includes(".pdf") ? "dlPdf" : "dlImgMain" }`}
          onClick={(e) => {
            if (e.target.tagName.toLowerCase() !== "input") {
              val?.attributeType !== "text" &&
                !val?.complianceFile?.name.includes(".pdf") &&
                handleOpen(val?.complianceFile?.url);
            }
          }}
        >
          <div className="dlImgBg"></div>
          <img
            src={
              val?.complianceFile?.name.includes(".pdf")
                ? pdf
                : val?.complianceFile?.url
            }
            alt="driving"
            className="dlImg"
          />
        </div>

        <Grid item container direction="row" justifyContent="space-between" alignItems="flex-end">
          <Grid item xs={10}>
            <h1 className="colorBlack font14 fontMedium">
              {val?.complianceName}
              {val?.isMandatory && <span className="colorRed">*</span>}
            </h1>
            {val?.number && (
              <p className="font12 fontNormal colorGrey">
                {"Number: " + (val?.atributeValue || val?.number || "N/A")}
              </p>
            )}

            {val?.isExpiring && (
              <p className="font12 fontNormal colorPrimary">
                <span className="colorPrimary">Exp:&nbsp; </span>
                {getDateFormat(val?.expiryDate, "moreDetails")}
              </p>
            )}
            {val?.status && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '5px' }}>
                <Tooltip title={val?.rejectionReason || ""}>
                  <Typography
                    className={`${val?.status === "Approved" && isExpired(val?.expiryDate) ? "RejectedBtn" : val?.status + "Btn"} flexDirection`}
                    style={{ border: 'none', background: 'transparent', padding: 0 }}
                  >
                    {val?.status === "Approved" && isExpired(val?.expiryDate) ? (
                      <span className="font14">
                        <span className="colorRed">Expired (</span>
                        <span className="colorGrey">Approved</span>
                        <span className="colorRed">)</span>
                      </span>
                    ) : (
                      val?.status
                    )}
                  </Typography>
                </Tooltip>

                {/* SHOW REUPLOAD ICON IF REJECTED OR EXPIRED */}
                {showReupload && (
                  <Tooltip title="Reupload">
                    <CloudSyncOutlinedIcon
                      className="cursor"
                      style={{ color: '#2e7d32', fontSize: '24px' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onReuploadClick(val);
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            )}
          </Grid>
          <Grid item>
            <div className="colorGrey textCenter marginTop mb10">
              <span className="cursor">
                <a href={val?.complianceFile?.url} download={val?.name}>
                  <img src={download} alt="download icon" />
                </a>
              </span>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default CommonCardDetails;
